import React, { Component } from "react";
import { defineMessages } from "react-intl";
import DatePickerFormGroup from "assets/scripts/components/common/form/DatePickerFormGroup/DatePickerFormGroup";
import TextFormGroup from "assets/scripts/components/common/form/TextFormGroup/TextFormGroup";
const messages = defineMessages({
    dateHelp: {
        id: "forms.accountValidtion.valdation.dateHelp",
        defaultMessage: "Format: MM/DD/YYYY"
    }
});
export default class ValidationFormGroup extends Component {
    constructor(props, context) {
        super(props, context);
        this._handleChange = this._handleChange.bind(this);
    }
    render() {
        const { props } = this;
        const { requirement, value, error } = props;
        const label = props.locale === "es" ? requirement.labelES : requirement.label;
        const formGroupProps = {
            name: `validation-${requirement.id}`,
            label,
            error,
            value,
            onChange: this._handleChange,
            required: true
        };
        if (requirement.type.toLowerCase() === "date") {
            return (<DatePickerFormGroup {...formGroupProps} help={messages.dateHelp}/>);
        }
        return (<TextFormGroup {...formGroupProps}/>);
    }
    _handleChange(value) {
        this.props.onChange(this.props.requirement.id, value);
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/ValidtationFieldset/ValidationFormGroup/ValidationFormGroup.tsx